module.exports = __webpack_public_path__ + "img/slider7.0b77d0a5.jpg";